import {ApolloClient, HttpLink, InMemoryCache, Observable, from} from '@apollo/client';
import {setContext} from '@apollo/client/link/context';
import {onError} from '@apollo/client/link/error';

import {StudentBoot} from './boot';
import {StudentSession} from './studentSession';

// Cliente proprio do app do aluno, e nao os de core/stores.ts: aqueles apontam
// para /:account/admin/graphql e leem o token do painel em localStorage. O
// aluno usa /:account/graphql com o JWT curto emitido pela sessao.
export const buildStudentClient = (boot: StudentBoot, session: StudentSession) => {
  const authLink = setContext(async (_operation, {headers}) => ({
    headers: {
      ...headers,
      authorization: `Bearer ${await session.currentToken()}`,
    },
  }));

  const errorLink = onError(({networkError, operation, forward}) => {
    const status = (networkError as {statusCode?: number} | null)?.statusCode;

    // Um 401 aqui significa token vencido antes da margem de renovacao —
    // renova uma vez e repete a operacao, em vez de quebrar a tela.
    if (status !== 401) return undefined;

    // Precisa ser Observable, e nao Promise: o error link faz
    // retriedResult.subscribe(...) (@apollo/client/link/error), entao devolver
    // uma Promise lança TypeError e o retry nunca acontece.
    return new Observable((observer) => {
      let inner: {unsubscribe: () => void} | undefined;

      session
        .refresh()
        .then(() => {
          inner = forward(operation).subscribe(observer);
        })
        .catch((erro) => observer.error(erro));

      return () => inner?.unsubscribe();
    });
  });

  return new ApolloClient({
    link: from([errorLink, authLink, new HttpLink({uri: boot.graphqlPath})]),
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {fetchPolicy: 'cache-and-network'},
    },
  });
};
